import { Clock, BarChart3, Shield, CreditCard } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useInView } from '@/hooks/useInView';
import { PLATFORM_STATS, RESEARCH_STATS } from '@/data/proofStats';

const trustPoints = [
  {
    icon: Clock,
    text: '5-Minute Setup',
  },
  {
    icon: BarChart3,
    text: 'DORA Research-Backed',
  },
  {
    icon: Shield,
    text: 'SOC 2-Aligned Controls',
  },
  {
    icon: CreditCard,
    text: 'Free Up to 10 Developers',
  },
];

const proofStats = [
  {
    value: RESEARCH_STATS.benchmark2025_prs.value,
    label: RESEARCH_STATS.benchmark2025_prs.label,
    href: RESEARCH_STATS.benchmark2025_prs.sourceUrl,
  },
  {
    value: PLATFORM_STATS.developersRepresented.value,
    label: PLATFORM_STATS.developersRepresented.label,
  },
  { value: PLATFORM_STATS.historyDepth.value, label: PLATFORM_STATS.historyDepth.label },
];

export default function TrustLogos() {
  const [sectionRef, isInView] = useInView<HTMLElement>({ threshold: 0.3 });

  return (
    <section
      ref={sectionRef}
      className="py-8 bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Trust Badges */}
        <div
          className={`flex flex-wrap items-center justify-center gap-6 sm:gap-8 ${
            isInView ? 'animate-fade-in-up' : 'opacity-0'
          }`}
        >
          {trustPoints.map((point, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-gray-600 dark:text-gray-300"
            >
              <point.icon className="w-4 h-4 text-gray-400 dark:text-gray-500" />
              <span className="text-sm font-medium">{point.text}</span>
            </div>
          ))}
        </div>

        {/* Social Proof Stats */}
        <div
          className={`flex flex-wrap items-center justify-center gap-8 sm:gap-12 mt-6 pt-6 border-t border-gray-100 dark:border-gray-800 ${
            isInView ? 'animate-fade-in-up animation-delay-150' : 'opacity-0'
          }`}
        >
          {proofStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-lg sm:text-xl font-bold text-primary-600 dark:text-primary-400">
                {stat.value}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {stat.label}
              </div>
              {stat.href && (
                <Link
                  to={stat.href}
                  className="mt-1 inline-block text-[11px] text-primary-600 hover:underline dark:text-primary-400"
                >
                  View methodology
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
